import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "wholeArea" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["placeholder", "maxlength", "disabled"]
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Description = _resolveComponent("Description")!
  const _component_CommentHistory = _resolveComponent("CommentHistory")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle({display:_ctx.isCommentHistoryRight ? 'inline-block': 'block', 'vertical-align':_ctx.isCommentHistoryRight ? 'top': 'initial'})
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["iframe-wrap-wrap", _ctx.iframeWrapWrapClass])
      }, [
        _createElementVNode("div", {
          class: "iframe-parent",
          style: _normalizeStyle(_ctx.iframeWrapStyle)
        }, [
          _createElementVNode("iframe", {
            style: _normalizeStyle([{"position":"absolute","top":"1","left":"1","border":"none","box-sizing":"content-box","transform-origin":"0 0","user-select":"none"}, _ctx.iframeStyle]),
            src: _ctx.kiwiIframeURL,
            frameborder: "1",
            scrolling: "no",
            id: "viewIframe",
            allow: "autoplay;camera *;microphone *;geolocation;"
          }, null, 12, _hoisted_2),
          _createVNode(_component_Loading, {
            ref: "loading",
            class: "loading",
            fadein: false
          }, null, 512)
        ], 4)
      ], 2),
      (!_ctx.isCommentHistoryRight)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_Description, {
              showDescription: _ctx.showDescription,
              publicPageData: _ctx.publicPageData
            }, null, 8, ["showDescription", "publicPageData"])
          ]))
        : _createCommentVNode("", true)
    ], 4),
    _createElementVNode("div", {
      style: _normalizeStyle(_ctx.commentHistoryWrapStyle)
    }, [
      _createVNode(_component_CommentHistory, {
        ref: "commentHistory",
        isPreview: _ctx.isPreview,
        isRightPosition: _ctx.isCommentHistoryRight
      }, null, 8, ["isPreview", "isRightPosition"])
    ], 4),
    (_ctx.isCommentHistoryRight)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_Description, {
            showDescription: _ctx.showDescription,
            publicPageData: _ctx.publicPageData
          }, null, 8, ["showDescription", "publicPageData"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: "commentInput",
      class: "bottom-comment-input",
      style: _normalizeStyle(_ctx.commentInputStyle)
    }, [
      _withDirectives(_createElementVNode("textarea", {
        style: {"resize":"vertical"},
        rows: "1",
        class: "form-control",
        name: "content",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.commentInputText) = $event)),
        type: "text",
        placeholder: _ctx.$root.account.isLogin ? 'コメント欄は広げることができます' : 'コメントするにはログインしてください',
        maxlength: _ctx.$root.const.commnentMaxLen,
        disabled: !_ctx.$root.account.isLogin,
        onKeydown: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.preventKeyEventToIframe && _ctx.preventKeyEventToIframe(...args)), ["stop"])),
        onKeypress: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.preventKeyEventToIframe && _ctx.preventKeyEventToIframe(...args)), ["stop"])),
        onKeyup: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.preventKeyEventToIframe && _ctx.preventKeyEventToIframe(...args)), ["stop"]))
      }, null, 40, _hoisted_5), [
        [_vModelText, _ctx.commentInputText]
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary",
        style: {"margin-left":"8px","overflow":"hidden","font-size":"smaller","padding":"8px 2px"},
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onComment && _ctx.onComment(...args))),
        disabled: !_ctx.$root.account.isLogin || !_ctx.commentInputText || _ctx.isPreview
      }, " コメント ", 8, _hoisted_6)
    ], 4)
  ]))
}